module.exports = __webpack_public_path__ + "img/cat2.f43d693.png";